export enum TipOptions {
  RECURRENT = 'RECURRENT',
  ONE_TIME = 'ONE_TIME',
}

export enum ProductType {
  subscription = 'subscription',
  common = 'common'
}

export enum Pages {
  howItWorks = 'howItWorks',
  ourStory = 'ourStory',
  cornMaze = 'cornMaze',
  onFarmStore = 'onFarmStore',
  schoolFieldTrips = 'schoolFieldTrips',
  ourGuidingPrinciples = 'ourGuidingPrinciples',
  familyAndTem = 'familyAndTem',
  product = 'product',
  faq = 'faq',
  atlantaDeliverySchedule = 'atlantaDeliverySchedule',
  directionsToFarm = 'directionsToFarm',
  producers = 'producers'
}

export enum SuggestedProductsType {
  marketplace = 'marketplace',
  favorite = 'favorite',
  buyAgain = 'buyAgain'
}